import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "table-responsive" }
const _hoisted_3 = { class: "table table-row-bordered table-hover align-middle mb-0 text-center" }
const _hoisted_4 = { class: "fw-bold fs-6 text-gray-800" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("th", null, "État de la candidature", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "fa-solid fa-rotate-right fa-xl",
  style: {"color":"#ff8040"},
  title: "Entreprise relancée"
}
const _hoisted_8 = {
  key: 1,
  class: "fa-solid fa-handshake fa-xl",
  style: {"color":"#00a800"},
  title: "Acceptée"
}
const _hoisted_9 = {
  key: 2,
  class: "fa-solid fa-x fa-xl",
  style: {"color":"#ff0000"},
  title: "Refusée"
}
const _hoisted_10 = {
  key: 3,
  class: "fa-solid fa-envelope-circle-check fa-xl",
  style: {"color":"#ff8040"},
  title: "Candidature envoyée"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-pen",
  title: "Éditer"
}, null, -1)
const _hoisted_12 = {
  key: 1,
  class: "alert alert-primary d-flex align-items-center p-5"
}
const _hoisted_13 = { class: "d-flex flex-column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BasicCard = _resolveComponent("BasicCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.suivis?.length)
      ? (_openBlock(), _createBlock(_component_BasicCard, {
          key: 0,
          "no-inline-border": "",
          "explicit-containment": "",
          class: "mb-5"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("table", _hoisted_3, [
                _createElementVNode("thead", _hoisted_4, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('views.portal.search.suiviRechercheEmployeur.card.table.thead.targetCompany')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('views.portal.search.suiviRechercheEmployeur.card.table.thead.position')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('views.portal.search.suiviRechercheEmployeur.card.table.thead.applicationDate')), 1),
                    _hoisted_5,
                    _hoisted_6
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suivis, (suivi) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: suivi.id
                    }, [
                      _createElementVNode("td", null, _toDisplayString(suivi.suiviEmployeur), 1),
                      _createElementVNode("td", null, _toDisplayString(suivi.suiviPosition), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(suivi.suiviDateEnvoiCandidature)), 1),
                      _createElementVNode("td", null, [
                        (suivi.suiviStatut === 'relance')
                          ? (_openBlock(), _createElementBlock("i", _hoisted_7))
                          : (suivi.suiviStatut === 'positif')
                            ? (_openBlock(), _createElementBlock("i", _hoisted_8))
                            : (suivi.suiviStatut === 'negatif')
                              ? (_openBlock(), _createElementBlock("i", _hoisted_9))
                              : (_openBlock(), _createElementBlock("i", _hoisted_10))
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_router_link, {
                          to: { name: 'form-suivi-recherche-employeur',  params: { id: suivi.id }},
                          class: "btn btn-light btn-light-info btn-icon"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('views.portal.search.suiviRechercheEmployeur.card.noData')), 1)
          ])
        ]))
  ]))
}